const NewBilling =() =>{

    return(
        <>
        
        </>
    )
}

export default NewBilling